import app from "./app";

const tg_pages = {
  pc: {
    accounts: {
      paper: {
        index: () => import("@/pages/pc/accounts/paper/index"),
        bet: () => import("@/pages/pc/accounts/paper/bet"),
      },
      history: {
        index: () => import("@/pages/pc/accounts/history/index"),
        user: () => import("@/pages/pc/accounts/history/index"),
      },
      bet: () => import("@/pages/pc/accounts/bet"),
      income: {
        index: () => import("@/pages/pc/accounts/income/index"),
        detail: () => import("@/pages/pc/accounts/income/detail"),
      },
      finance: () => import("@/pages/pc/accounts/finance"),
      transfer: () => import("@/pages/pc/accounts/transfer"),
      return_bonus: () => import("@/pages/pc/accounts/return_bonus"),
      profit: () => import("@/pages/pc/accounts/profit"),
      high_profit_members: () =>
        import("../pages/pc/accounts/high_profit_members"),
    },
    dashboard: () => import("@/pages/pc/dashboard/Index"),
    member: {
      board: () => import("@/pages/pc/member/board"),
      profile: () => import("@/pages/pc/member/profile"),
      sub: () => import("@/pages/pc/member/sub"),
      admin: () => import("@/pages/pc/member/admin"),
      trial: () => import("@/pages/pc/member/trial"),
      trial_apply: () => import("@/pages/pc/member/trial_apply"),
      distributed: () => import("@/pages/pc/member/distributed"),
    },
    tg_business: {
      privilege: () => import("@/pages/pc/tg_business/privilege"),
      member: {
        review: () => import("@/pages/pc/tg_business/member/review"),
        reward: {
          index: () => import("@/pages/pc/tg_business/member/reward"),
          games: () => import("@/pages/pc/tg_business/member/reward-games"),
          detail: () => import("@/pages/pc/tg_business/member/reward-detail"),
        },
        privilege: () =>
          import("@/pages/pc/tg_business/member/privilege/index"),
        board: () => import("@/pages/pc/tg_business/member/board"),
      },
      announcement: {
        review: () => import("@/pages/pc/tg_business/announcement/review"),
      },
      "my-team": () => import("@/pages/pc/tg_business/team/index"),
      "reward-record": {
        index: () => import("@/pages/pc/tg_business/reward-record/index"),
        users: () => import("@/pages/pc/tg_business/reward-record/users"),
        detail: () => import("@/pages/pc/tg_business/reward-record/detail"),
      },
      "level-distributed": {
        index: () => import("@/pages/pc/tg_business/level-distributed/index"),
      },
      accounting: () => import("@/pages/pc/tg_business/accounting/index"),
      ranking: {
        bet_ranking: () => import("@/pages/pc/tg_business/ranking/betRanking"),
      },
    },
    activity: {
      record: {
        board: () => import("@/pages/pc/activity/board"),
        agent: () => import("@/pages/pc/activity/agent"),
        detail: () => import("@/pages/pc/activity/detail"),
      },
      member_search: () => import("@/pages/pc/activity/search"),
    },
    game: {
      bet: () => import("@/pages/pc/game/bet"),
      invest: () => import("@/pages/pc/game/invest"),
      result: () => import("@/pages/pc/game/result"),
      language: () => import("@/pages/pc/game/language"),
    },
    ip_white: () => import("@/pages/pc/ipWhite"),
    test: () => import("@/pages/pc/test"),
    service: () => import("@/pages/pc/service"),
    online: () => import("@/pages/pc/online"),
    notice: () => import("@/pages/pc/notice"),
    rule: () => import("@/pages/pc/rule"),
    assistence: () => import("@/pages/pc/assistence"),
    notOpen: () => import("@/pages/pc/notOpen"),
  },
  mobile: {},
};

tg_pages.mobile = tg_pages.pc;

export default {
  pages: tg_pages[app.layout],
};
